<template>
    <div>
        <form class="row mt-1" :action="route('analytics', view)" method="get">
            <div class="col-12 col-md-3">
                    <app-select
                        name="interval_type"
                        id="interval_type"
                        placeholder="Interval"
                        :use-search="false"
                        :is-multiple="false"
                        :options="intervals"
                        v-model="typeReport"
                    ></app-select>
                    </div>
            <div v-if="typeReport" class="col-12 col-md-3">
                    <app-input
                        :is-required="true"
                        v-if="typeReport === 'month'"
                        v-model=date
                        placeholder="Chart Date"
                        type="month"
                        id="chart_date"
                        name="chart_date"
                    ></app-input>
                    <date-picker
                        :is-required="true"
                        v-if="typeReport === 'day'"
                        v-model=date
                        placeholder="Chart Date"
                        name="chart_date"
                        id="chart_date"
                        :config="config"
                    ></date-picker>
                </div>
            <div class="col-12 col-md-3">
                <button-set class="row ">
                    <app-button class="col" type="light" :link="route('analytics', view)">
                        <ion-icon name="refresh-outline"></ion-icon>
                        Reset
                    </app-button>

                    <app-button
                        class="col"
                        type="primary"
                        submit="submit"
                        :link="route('analytics', view)">
                        <ion-icon name="search-outline"></ion-icon>
                        Filter
                    </app-button>
                </button-set>
                </div>
        </form>
    </div>
</template>


<script>
export default {
    props: {
        view: {
            type: Number,
            default: ''
        },
        original: {
            type: String,
            default: "year",
        },
        interval: {
            type: String,
            default: "",
        },
        intervals: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            config:{"enableTime":false,"maxDate":"today"},
            changeDescription: false,
            typeReport: this.interval,
            description: '',
            loading: false,
            date: this.original,
            mode : 'single'

    }
    },
}
</script>
